import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ConnectivityTool.css';

export default function ConnectivityTool() {
  return (
    <div className="ct-page">
      <div className="ct-hero">
        <div className="ct-hero-content">
          <div className="ct-badge">COMING SOON</div>
          <h1 className="ct-hero-title">Connectivity App</h1>
          <p className="ct-hero-subtitle">
            A powerful resource connecting LGBTQ+ travelers with queer-friendly 
            businesses, communities, and services across the Caribbean.
          </p>
        </div>
      </div>

      <div className="ct-mockups">
        <div className="ct-mockup">
          <img src="/assets/connectivity_app_2.jpeg" alt="OutCaribbean App - Home Screen" />
        </div>
        <div className="ct-mockup">
          <img src="/assets/connectivity_app_1.jpeg" alt="OutCaribbean App - Profile Screen" />
        </div>
      </div>

      <div className="ct-body">
        <div className="ct-features">
          <div className="ct-feature">
            <div className="ct-feature-number">01</div>
            <h3 className="ct-feature-title">Community Network</h3>
            <p className="ct-feature-text">
              Connect with local LGBTQ+ communities and allies across Caribbean destinations.
            </p>
          </div>
          <div className="ct-feature">
            <div className="ct-feature-number">02</div>
            <h3 className="ct-feature-title">Business Directory</h3>
            <p className="ct-feature-text">
              Find verified queer-friendly hotels, restaurants, and experiences.
            </p>
          </div>
          <div className="ct-feature">
            <div className="ct-feature-number">03</div>
            <h3 className="ct-feature-title">Safety Resources</h3>
            <p className="ct-feature-text">
              Access up-to-date safety information and local support contacts.
            </p>
          </div>
        </div>

        <div className="ct-cta">
          <p className="ct-cta-text">We're working hard to bring this to you. Check back soon!</p>
          <Link to="/" className="ct-back-btn">Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
